import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import defaultGetWasChanged from '../defaultGetWasChanged';
import defaultGetError from '../defaultGetError';
import { constructFieldKey } from './constructFieldKey';

/**
 * This function takes the form's field definitions
 * as well as the current React state (`fieldStates`),
 * and computes the `fields` object that is returned
 * by the `useForm` hook.
 */

export function getAugmentedFieldStates(fields, createFieldsForEachId, fieldStates, setFieldStates) {
  var augmentedFieldStates = {};
  Object.entries(fields).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      unknownField = _ref2[1];
    function getFieldObject(fieldKey, id) {
      var fieldDef = unknownField;
      var _fieldDef$getError = fieldDef.getError,
        getError = _fieldDef$getError === void 0 ? defaultGetError : _fieldDef$getError,
        _fieldDef$getWasChang = fieldDef.getWasChanged,
        getWasChanged = _fieldDef$getWasChang === void 0 ? defaultGetWasChanged : _fieldDef$getWasChang;
      var fieldState = fieldStates[fieldKey];
      if (!fieldState) {
        var defaultValue = id ? fieldDef.getDefaultValue(id) : fieldDef.getDefaultValue();
        fieldState = {
          defaultValue: defaultValue,
          value: defaultValue,
          changedValue: undefined,
          wasChanged: false
        };
      }
      var error = getError(fieldState.value, fieldDef);
      var fieldObject = _objectSpread(_objectSpread({}, fieldState), {}, {
        error: error,
        isValid: !error,
        set: function set(newValue) {
          return setFieldStates(function (prevState) {
            var value = newValue instanceof Function ? newValue(fieldState.value) : newValue;
            var wasChanged = getWasChanged(fieldState.defaultValue, value);
            return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, fieldKey, _objectSpread(_objectSpread({}, fieldState), {}, {
              value: value,
              wasChanged: wasChanged,
              changedValue: wasChanged ? value : undefined
            })));
          });
        },
        reset: function reset() {
          return setFieldStates(function (prevState) {
            var defaultValue = id ? fieldDef.getDefaultValue(id) : fieldDef.getDefaultValue();
            return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, fieldKey, {
              value: defaultValue,
              defaultValue: defaultValue,
              wasChanged: false,
              changedValue: undefined
            }));
          });
        }
      });
      return fieldObject;
    }
    augmentedFieldStates[key] = createFieldsForEachId ? function (id) {
      return getFieldObject(constructFieldKey(key, id), id);
    } : getFieldObject(key);
  });
  return augmentedFieldStates;
}